import request from '@/API/';

export default {
  saveUser: (payload) => {
    return request.post('user', payload);
  },
  inviteUser: (payload) => {
    return request.post('user/invite', payload);
  },
  removeUser: (payload) => {
    return request.post('user/remove', payload);
  },
  fetchUsers: (payload) => {
    if(payload) { return request.get(`user/users?cid=${payload}`); }
    return request.get(`user/users`);
  },
  fetchClients: () => {
    return request.get('user/clientlist?s=user')
  },
  setRole: (payload) => {
    return request.get('user/role?c='+payload.c+'&u='+payload.u+'&b='+payload.b+'&a='+payload.a)
  }
};
